import * as types from './types';

export const getUserSettingsRequest = (data) => ({ type: types.GET_USER_SETTINGS_REQUEST, data });
export const getUserSettingsRequestFailure = (error) => ({ type: types.GET_USER_SETTINGS_REQUEST_FAILURE, error });
export const getUserSettingsRequestSuccess = (data) => ({ type: types.GET_USER_SETTINGS_REQUEST_SUCCESS, data });

export const updateUserSettingsRequest = (data) => ({ type: types.UPDATE_USER_SETTINGS_REQUEST, data });
export const updateUserSettingsRequestFailure = (error) => ({ type: types.UPDATE_USER_SETTINGS_REQUEST_FAILURE, error });
export const updateUserSettingsRequestSuccess = (data) => ({ type: types.UPDATE_USER_SETTINGS_REQUEST_SUCCESS, data });

export const showIntacctId = (data) => ({ type: types.SHOW_INTACCT_ID, data });
export const hideIntacctId = (data) => ({ type: types.HIDE_INTACCT_ID, data });
